export default [{"url":"https://brandify-0.api.invexerp.io","name":"Branch 1","port":"6531","isStore":true,"isHQ":true}]